/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dispatcher, ILiveStreamSettings, RootState } from 'AppTypes'
import { Field, Form, Formik } from 'formik'
import { AT_WORK_TIME, SPECIFY_TIME } from '@app/models/liveStreamSettings'
import { publicSettingChange, timeToPlayChange, updateLiveStreamSettings } from '../state_management/actions'

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  doUpdateLiveStreamSettings: () => dispatch(updateLiveStreamSettings()),
  doPublicSettingChange: (isPublish: boolean) => dispatch(publicSettingChange(isPublish)),
  doTimeToPlayChange: (timeToPlay: string) => dispatch(timeToPlayChange(timeToPlay))
})

const mapStateToProps = (state: RootState) => ({
  settings: state.liveStream.liveStreamSettings
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const LiveStreamSettings: React.FC<Props> = ({
  settings,
  doUpdateLiveStreamSettings,
  doPublicSettingChange,
  doTimeToPlayChange
}) => {
  const { t } = useTranslation()

  const onPublicChange = (strPublic: boolean) => {
    doPublicSettingChange(strPublic)
  }

  const onTimeToPlayChange = (timeToPlay: string) => {
    doTimeToPlayChange(timeToPlay)
  }

  const onSave = () => {
    doUpdateLiveStreamSettings()
  }

  return (
    <>
      <div className="row">
        <label className=" col-lg-3 col-xl-2 col-form-label" htmlFor="">{t('liveStream.publishingSettings')}</label>
        <div className=" col-lg-9 col-xl-10">
          <div className="btn-group btn-group-toggle" data-toggle="buttons">
            <label className={settings.isPublish ? 'btn active' : 'btn'} onClick={() => onPublicChange(true)}>
              <input type="radio" name="isPublish" id="public" value="public" /> {t('liveStream.public')}
            </label>
            <label className={!settings.isPublish ? 'btn active' : 'btn'} onClick={() => onPublicChange(false)}>
              <input type="radio" name="isPublish" id="nonpublic" value="nonpublic" /> {t('liveStream.private')}
            </label>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <label className="col-lg-3 col-xl-2 col-form-label" htmlFor="">{t('liveStream.liveTime')}</label>
        <div className="col-lg-9 col-xl-10">
          <div className="btn-group btn-group-toggle" data-toggle="buttons">
            <label className={settings.timeToPlay === AT_WORK_TIME ? 'btn active' : 'btn'} htmlFor="option_b1" onClick={() => onTimeToPlayChange(AT_WORK_TIME)}>
              <input type="radio" name="timeToPlay" value={AT_WORK_TIME} id="option_b1" autoComplete="off" /> {t('liveStream.businessHoursOnly')}
            </label>
            <label className={settings.timeToPlay === SPECIFY_TIME ? 'btn active' : 'btn'} htmlFor="option_b2" onClick={() => onTimeToPlayChange(AT_WORK_TIME)}>
              <input type="radio" name="timeToPlay" value={SPECIFY_TIME} id="option_b2" autoComplete="off" /> {t('liveStream.specificTime')}
            </label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <label className="col-2 col-form-label" htmlFor="" />
        <div className="col-10">
          <button type="button" onClick={onSave} className="btn btn-block bg-danger" style={{ width: 340 }}>{t('liveStream.save')}</button>
        </div>
      </div>
    </>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamSettings)
